// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pu-0";
export var animationContainer = "_pu-1";
export var itemPrice = "_pu-a";
export var itemizedContent = "_pu-9";
export var itemizedHeader = "_pu-7";
export var itemizedRow = "_pu-8";
export var itemizedSection = "_pu-6";
export var modalContent = "_pu-2";
export var orderName = "_pu-3";
export var refundOption = "_pu-4";
export var refundOptionsContainer = "_pu-5";
export var shippingLabel = "_pu-b";
export var totalRow = "_pu-c";